<p-dialog
  modal="true" [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div>
    {{
      text
        ? ('communications.mass-comm-message-edit.message-edit.internal-html-warning' | translate)
        : ('communications.mass-comm-message-edit.message-edit.external-html-warning' | translate)
    }}
  </div>
  <div class="mv-10">{{ 'communications.mass-comm-message-edit.message-edit.are-you-sure' | translate | ucfirst }}</div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      <i class="pi pi-ban"></i>
      {{ 'common.cancel' | translate | ucfirst }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="toggleMessageText()">
      {{
        text
          ? ('communications.mass-comm-message-edit.message-edit.use-internal-editor' | translate | titlecase)
          : ('communications.mass-comm-message-edit.message-edit.use-external-html' | translate)
      }}
    </button>
  </ng-template>
</p-dialog>
